import { useEffect } from 'react'
import { Button, Card, Table, Tag, Tooltip } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { SearchOutlined } from '@ant-design/icons'
import { path } from 'src/libs'
import { useWebPageList } from 'src/pages/ib/adMaterials/webSitePages/hooks'
import { onChangeWebSiteList } from 'src/pages/ib/adMaterials/webSitePages/model'
import { WebSiteItem } from 'src/pages/ib/adMaterials/webSitePages/types'

export const WebSitePageList = () => {
  const { loading, webSiteList, totalCountOfItems } = useWebPageList()

  useEffect(() => {
    onChangeWebSiteList({ page: 1, limit: 10 })
  }, [])

  const columns: ColumnsType<WebSiteItem> = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Link',
      dataIndex: 'link',
    },
    {
      title: 'Status',
      dataIndex: 'isVisible',
      render: (status: boolean) => {
        return (
          <Tag color={status ? 'success' : 'error'}>
            {status ? 'Active' : 'Inactive'}
          </Tag>
        )
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <Tooltip title="Редактировать ссылку">
            <Button href={path.ib.ad.website_pages.edit(item.id)}>
              <SearchOutlined />
            </Button>
          </Tooltip>
        )
      },
    },
  ]

  return (
    <Card>
      <Button
        color="blue"
        size="large"
        variant="solid"
        type="link"
        href={path.ib.ad.website_pages.create()}
        style={{ marginBottom: 24, textDecoration: 'none' }}
      >
        Create Website link
      </Button>
      <Table
        dataSource={webSiteList}
        className="overflow-auto"
        loading={loading}
        rowKey="id"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfItems,
          hideOnSinglePage: true,
        }}
        onChange={(pagination) =>
          onChangeWebSiteList({
            page: pagination.current ?? 1,
            limit: pagination.pageSize ?? 10,
          })
        }
      />
    </Card>
  )
}
